import { render, staticRenderFns } from "./RentalCart.vue?vue&type=template&id=28071568&scoped=true&"
import script from "./RentalCart.vue?vue&type=script&lang=ts&"
export * from "./RentalCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28071568",
  null
  
)

export default component.exports